import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { forwardRef, memo, useState } from 'react';
import classNames from 'classnames/bind';
import { Tabs, Text } from '@beef/ui-kit';
import { useGetDimensionGroup } from "../../hooks/useGetDimensionGroup";
import style from "./styles.module.pcss";
import { ExpandingContent } from "./ExpandingContent";
import { SEO_TYPE_MAIN_BLOCK, SEO_TYPE_QUESTION } from "./constants";
var cn = classNames.bind(style);
var DEFAULT_TAB_ID = '1';
var OUTER_SPACE_VALUE = {
  mobile: 24,
  tablet: 32,
  desktop: 80
};
export var Faq = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _categories$;
  var _ref$categories = _ref.categories,
    categories = _ref$categories === void 0 ? [] : _ref$categories,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Частые вопросы' : _ref$title,
    onClick = _ref.onClick;
  var _useState = useState(((_categories$ = categories[0]) === null || _categories$ === void 0 ? void 0 : _categories$.id) || DEFAULT_TAB_ID),
    _useState2 = _slicedToArray(_useState, 2),
    topTabId = _useState2[0],
    setTopTabId = _useState2[1];
  var dimensionType = useGetDimensionGroup();
  var onChangeTopTab = function onChangeTopTab(id) {
    if (id !== topTabId) {
      setTopTabId(id || DEFAULT_TAB_ID);
      if (onClick) {
        onClick({
          tabId: id,
          panelId: ''
        });
      }
    }
  };
  var handleExpandClick = function handleExpandClick(id) {
    if (onClick) {
      onClick({
        tabId: '',
        panelId: id
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn('faq'),
    itemScope: true,
    itemType: SEO_TYPE_MAIN_BLOCK,
    ref: ref,
    "data-t-id": "components-FAQ"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('title')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size2-m"
  }, title)), (categories === null || categories === void 0 ? void 0 : categories.length) > 1 && /*#__PURE__*/React.createElement("div", {
    className: cn('top-nav')
  }, /*#__PURE__*/React.createElement(Tabs, {
    isScrollable: true,
    noWrap: true,
    onChange: onChangeTopTab,
    outerSpaceValue: OUTER_SPACE_VALUE[dimensionType || 'mobile'],
    selectedTab: topTabId,
    tabs: categories,
    variant: "tertiary"
  })), (data === null || data === void 0 ? void 0 : data.length) > 0 && data.map(function (_ref2) {
    var categoryId = _ref2.categoryId,
      tabs = _ref2.tabs;
    return /*#__PURE__*/React.createElement("div", {
      className: cn('hidden', categoryId === topTabId && 'visibly'),
      key: categoryId
    }, (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 0 && tabs.map(function (tab) {
      return /*#__PURE__*/React.createElement("div", {
        className: cn('expandingPanel-wrapper'),
        itemProp: "mainEntity",
        itemScope: true,
        itemType: SEO_TYPE_QUESTION,
        key: tab.id
      }, /*#__PURE__*/React.createElement(ExpandingContent, {
        content: tab.content,
        onClick: function onClick() {
          handleExpandClick(tab.id);
        },
        title: tab.title
      }));
    }));
  }));
}));
Faq.displayName = Faq.name;